import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";
import { BolsaMultiConfigAjusteProdParmDTO } from "@/interfaces/splitted-bag-config";

export function listSplittedBagConfigsWeekdays(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.SPLITTED_BAG_CONFIG_WEEKDAYS)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function listSplittedBagConfigs(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.SPLITTED_BAG_CONFIG)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function saveSplittedBagConfigs(parm: BolsaMultiConfigAjusteProdParmDTO): Observable<string> {
  return from(apiClient.post(ENDPOINTS.SPLITTED_BAG_CONFIG, parm)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function deleteSplittedBagConfigs(id: number): Observable<string> {
  return from(apiClient.delete(`${ENDPOINTS.SPLITTED_BAG_CONFIG}/${id}`)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}